// The MISMO endpoints hand back raw Go error strings ("Error creating new borrower:
// account validated", "failed to decode MISMO XML: ..."). Map the ones a loan officer
// can actually act on to plain language, and fall back to a generic line for the rest
// so internal wording never reaches the screen.

export const GENERIC_IMPORT_ERROR = "We couldn't read this MISMO file. Please check the file and try again."
export const GENERIC_CREATE_LOAN_ERROR = "We couldn't create the application from this file. Please try again, and contact support if it keeps happening."
export const SESSION_EXPIRED_ERROR = 'Your session has expired. Please sign in again and retry the import.'

const IMPORT_ERRORS = [
    {
        match: /no borrowers found/i,
        message: 'No borrower was found in this file. Please re-export it with at least one borrower and upload it again.',
    },
    {
        match: /failed to decode MISMO XML|XML syntax|unexpected EOF/i,
        message: "This file isn't valid MISMO XML. Please re-export it from your system and upload the new file.",
    },
    {
        match: /No file uploaded|invalid file field|Failed to parse form/i,
        message: "We didn't receive the file. Please choose it again and re-upload.",
    },
    {
        match: /MISMO server not configured|Failed to forward request to MISMO server/i,
        message: 'The import service is temporarily unavailable. Please try again in a few minutes.',
    },
]

const CREATE_LOAN_ERRORS = [
    {
        match: /account validated/i,
        message: 'A borrower with this email address already has an account. Open that borrower and start the new application from their profile.',
    },
    // The primary borrower's email is the one the loan is filed under, so a file
    // without one cannot be imported at all. Co-borrowers no longer need one -
    // an entity co-borrower has no inbox to give - so this can only be the first
    // borrower, and the message names what to fix rather than saying "try again".
    {
        match: /missing borrower email/i,
        message: "This file has no email address for the primary borrower. Please add one where the file was exported from, then upload it again.",
    },
    // No rule for "duplicate key ... unique constraint": merged.customers has no unique
    // index on email, so a collision there is never about the borrower already existing.
    // The ones that do occur are internal (e.g. idx_loanstates_pkey) and belong in the
    // generic bucket rather than under a misleading explanation.
    {
        match: /timeout|deadline exceeded|connection refused|too many connections/i,
        message: 'The server is busy right now. Please wait a moment and try again.',
    },
]

const resolve = (rules, rawError, fallback) => {
    const text = typeof rawError === 'string' ? rawError : ''
    const rule = rules.find((r) => r.match.test(text))
    if (rule) {
        return rule.message
    }
    if (text) {
        // Unmapped errors still need to be recoverable by support.
        console.error('[ImportMISMOFile]', text)
    }
    return fallback
}

export const importErrorMessage = (rawError) => resolve(IMPORT_ERRORS, rawError, GENERIC_IMPORT_ERROR)

export const createLoanErrorMessage = (rawError) => resolve(CREATE_LOAN_ERRORS, rawError, GENERIC_CREATE_LOAN_ERROR)
